import { useNavigate } from "react-router-dom";
import "../index.css";
import Navbar from "../component/navbar/Navbar";
import Footer from "../screens/Footer/Footer";
import { useEffect } from "react";
import {
  Box,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import SearchBar from "../component/common/icon-searchbar/IconSearchBar";
import { BsArrowRight, BsPlay, BsCheckLg } from "react-icons/bs";
import { FaStar } from "react-icons/fa";
import count_service_img from "../assets/count_service_img.webp";

function HomeV2() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const features = [
    { title: "Same-day booking", desc: "Get help when you need it most" },
    { title: "Verified professionals", desc: "Background-checked & insured" },
    { title: "Satisfaction guaranteed", desc: "Or your money back" },
  ];

  const services = [
    { name: "Plumbing", jobs: "2.4k jobs", image: "🔧" },
    { name: "Electrical", jobs: "1.8k jobs", image: "⚡" },
    { name: "Cleaning", jobs: "3.2k jobs", image: "🧹" },
    { name: "Painting", jobs: "1.1k jobs", image: "🎨" },
    { name: "HVAC", jobs: "950 jobs", image: "❄️" },
    { name: "Handyman", jobs: "2.1k jobs", image: "🔨" },
  ];

  return (
    <div>
      <Navbar />

      {/* Hero - Gradient Background */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
          minHeight: "100vh",
          pt: { xs: 12, md: 16 },
          pb: { xs: 8, md: 12 },
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative circles */}
        <Box
          sx={{
            position: "absolute",
            top: "10%",
            right: "-5%",
            width: "400px",
            height: "400px",
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(241,90,36,0.15) 0%, transparent 70%)",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: "10%",
            left: "-10%",
            width: "500px",
            height: "500px",
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(241,90,36,0.1) 0%, transparent 70%)",
          }}
        />

        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={7}>
              <Stack spacing={4}>
                {/* Rating badge */}
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Stack direction="row" spacing={0.5}>
                    {[1,2,3,4,5].map(i => <FaStar key={i} size={14} color="#fbbf24" />)}
                  </Stack>
                  <Typography sx={{ color: "rgba(255,255,255,0.8)", fontSize: "14px" }}>
                    4.9 from 10,000+ reviews
                  </Typography>
                </Stack>

                <Typography
                  sx={{
                    fontSize: { xs: "40px", sm: "52px", md: "64px", lg: "72px" },
                    fontWeight: "800",
                    color: "#fff",
                    lineHeight: 1.05,
                    letterSpacing: "-0.03em",
                  }}
                >
                  Get it{" "}
                  <Box
                    component="span"
                    sx={{
                      background: "linear-gradient(90deg, #F15A24, #ff8a5c)",
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Done
                  </Box>
                  <br />
                  today.
                </Typography>

                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "20px" },
                    color: "rgba(255,255,255,0.7)",
                    lineHeight: 1.6,
                    maxWidth: "500px",
                  }}
                >
                  Book trusted home service professionals in minutes. From repairs to renovations, we've got you covered.
                </Typography>

                <Box sx={{ maxWidth: "500px" }}>
                  <SearchBar />
                </Box>

                {/* Feature pills */}
                <Stack direction="row" flexWrap="wrap" gap={2} mt={2}>
                  {["Plumbing", "Electrical", "Cleaning", "HVAC", "Painting"].map((service, i) => (
                    <Box
                      key={i}
                      onClick={() => navigate("/services")}
                      sx={{
                        px: 2.5,
                        py: 1,
                        borderRadius: "50px",
                        border: "1px solid rgba(255,255,255,0.2)",
                        color: "rgba(255,255,255,0.8)",
                        fontSize: "14px",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          borderColor: "#F15A24",
                          color: "#F15A24",
                          backgroundColor: "rgba(241,90,36,0.1)",
                        },
                      }}
                    >
                      {service}
                    </Box>
                  ))}
                </Stack>
              </Stack>
            </Grid>

            <Grid item xs={12} md={5} sx={{ display: { xs: "none", md: "block" } }}>
              <Box sx={{ position: "relative" }}>
                <Box
                  component="img"
                  src={count_service_img}
                  alt="Home Services"
                  sx={{
                    width: "100%",
                    borderRadius: "24px",
                    boxShadow: "0 30px 60px rgba(0,0,0,0.4)",
                  }}
                />
                {/* Floating card */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: -20,
                    left: -30,
                    backgroundColor: "#fff",
                    borderRadius: "16px",
                    p: 2.5,
                    boxShadow: "0 15px 40px rgba(0,0,0,0.2)",
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      sx={{
                        width: 50,
                        height: 50,
                        borderRadius: "12px",
                        backgroundColor: "#10b981",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <BsCheckLg size={24} color="#fff" />
                    </Box>
                    <Stack>
                      <Typography sx={{ fontWeight: "700", color: "#1a1a1a" }}>10,000+</Typography>
                      <Typography sx={{ fontSize: "13px", color: "#666" }}>Jobs completed</Typography>
                    </Stack>
                  </Stack>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Features Strip */}
      <Box sx={{ backgroundColor: "#F15A24", py: 4 }}>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            {features.map((feature, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      backgroundColor: "rgba(255,255,255,0.2)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <BsCheckLg size={18} color="#fff" />
                  </Box>
                  <Stack>
                    <Typography sx={{ fontWeight: "600", color: "#fff", fontSize: "16px" }}>
                      {feature.title}
                    </Typography>
                    <Typography sx={{ color: "rgba(255,255,255,0.8)", fontSize: "14px" }}>
                      {feature.desc}
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Services Section */}
      <Box sx={{ backgroundColor: "#fafafa", py: { xs: 8, md: 12 } }}>
        <Container maxWidth="lg">
          <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems={{ md: "center" }} mb={6} spacing={2}>
            <Stack>
              <Typography
                sx={{
                  fontSize: { xs: "32px", md: "42px" },
                  fontWeight: "700",
                  color: "#1a1a1a",
                  lineHeight: 1.2,
                }}
              >
                Popular services
              </Typography>
              <Typography sx={{ fontSize: "16px", color: "#666", mt: 1 }}>
                Choose from our most requested home services
              </Typography>
            </Stack>
            <Box
              onClick={() => navigate("/services")}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: "#F15A24",
                fontWeight: "600",
                cursor: "pointer",
                "&:hover": { gap: 2 },
                transition: "all 0.3s ease",
              }}
            >
              View all services <BsArrowRight />
            </Box>
          </Stack>

          <Grid container spacing={3}>
            {services.map((service, index) => (
              <Grid item xs={6} sm={4} md={2} key={index}>
                <Box
                  onClick={() => navigate("/services")}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "20px",
                    p: 3,
                    textAlign: "center",
                    cursor: "pointer",
                    border: "2px solid transparent",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                      borderColor: "#F15A24",
                    },
                  }}
                >
                  <Typography sx={{ fontSize: "40px", mb: 2 }}>{service.image}</Typography>
                  <Typography sx={{ fontWeight: "600", color: "#1a1a1a", mb: 0.5 }}>
                    {service.name}
                  </Typography>
                  <Typography sx={{ fontSize: "13px", color: "#999" }}>
                    {service.jobs}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* How It Works */}
      <Box sx={{ backgroundColor: "#fff", py: { xs: 8, md: 12 } }}>
        <Container maxWidth="lg">
          <Stack alignItems="center" textAlign="center" mb={8}>
            <Typography
              sx={{
                fontSize: { xs: "32px", md: "42px" },
                fontWeight: "700",
                color: "#1a1a1a",
              }}
            >
              How it works
            </Typography>
          </Stack>

          <Grid container spacing={4}>
            {[
              { step: "1", title: "Describe your project", desc: "Tell us what you need help with and when you're available.", color: "#3b82f6" },
              { step: "2", title: "Get matched", desc: "We'll connect you with top-rated pros in your area.", color: "#F15A24" },
              { step: "3", title: "Book instantly", desc: "Choose your pro, confirm the details, and you're all set.", color: "#10b981" },
            ].map((item, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Stack alignItems="center" textAlign="center" spacing={3}>
                  <Box
                    sx={{
                      width: 80,
                      height: 80,
                      borderRadius: "50%",
                      backgroundColor: `${item.color}15`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography sx={{ fontSize: "32px", fontWeight: "800", color: item.color }}>
                      {item.step}
                    </Typography>
                  </Box>
                  <Typography sx={{ fontSize: "22px", fontWeight: "600", color: "#1a1a1a" }}>
                    {item.title}
                  </Typography>
                  <Typography sx={{ fontSize: "15px", color: "#666", lineHeight: 1.7, maxWidth: "280px" }}>
                    {item.desc}
                  </Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CTA Banner */}
      <Box sx={{ backgroundColor: "#1a1a2e", py: { xs: 8, md: 10 } }}>
        <Container maxWidth="md">
          <Stack alignItems="center" textAlign="center" spacing={4}>
            <Typography
              sx={{
                fontSize: { xs: "28px", md: "40px" },
                fontWeight: "700",
                color: "#fff",
                lineHeight: 1.2,
              }}
            >
              Ready to get started?
            </Typography>
            <Typography sx={{ fontSize: "18px", color: "rgba(255,255,255,0.7)", maxWidth: "450px" }}>
              Join thousands of homeowners who trust Done for quality home services.
            </Typography>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <Box
                onClick={() => navigate("/services")}
                sx={{
                  background: "linear-gradient(90deg, #F15A24, #ff7849)",
                  color: "#fff",
                  px: 5,
                  py: 2,
                  borderRadius: "50px",
                  fontWeight: "600",
                  fontSize: "16px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  "&:hover": { transform: "scale(1.05)" },
                }}
              >
                Book a service
              </Box>
              <Box
                onClick={() => navigate("/become-vendor")}
                sx={{
                  border: "2px solid rgba(255,255,255,0.3)",
                  color: "#fff",
                  px: 5,
                  py: 2,
                  borderRadius: "50px",
                  fontWeight: "600",
                  fontSize: "16px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  "&:hover": { borderColor: "#fff" },
                }}
              >
                Become a pro
              </Box>
            </Stack>
          </Stack>
        </Container>
      </Box>

      <Footer />
    </div>
  );
}

export default HomeV2;
